import { Link } from "react-router-dom";
import type { Drama } from "@/types/drama";
import { formatDate } from "@/lib/drama";

interface DramaListCardProps {
  drama: Drama;
}

export default function DramaListCard({ drama }: DramaListCardProps) {
  return (
    <article className="group rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:p-4">
      <div className="flex gap-3 md:gap-4">
        <Link
          to={`/detail/${drama.id}`}
          className="relative shrink-0 w-[88px] h-[124px] md:w-[128px] md:h-[180px] overflow-hidden rounded-md bg-primary-900"
          aria-label={`查看《${drama.title}》详情`}
        >
          <img
            src={drama.cover}
            alt={`${drama.title} 剧集封面`}
            title={`${drama.title} 高清电视剧在线观看`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute top-1.5 left-1.5 rounded bg-accent-500 px-1 py-0.5 text-[10px] font-bold text-primary-950">
            {drama.rating.toFixed(1)}
          </span>
        </Link>

        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-start justify-between gap-2">
            <Link
              to={`/detail/${drama.id}`}
              className="font-heading text-base md:text-lg font-bold text-foreground-950 transition-colors hover:text-primary-600"
            >
              {drama.title}
            </Link>
            <span className="rounded-md bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-700 whitespace-nowrap">
              {drama.status}
            </span>
          </div>

          <p className="mt-1 text-xs text-foreground-500">
            {drama.year} · {drama.region} · {drama.genres.join(" / ")} · 导演 {drama.director}
          </p>
          <p className="mt-1 text-xs text-foreground-600 line-clamp-1">
            主演：{drama.cast.join("、")}
          </p>
          <p className="mt-2 hidden text-xs leading-relaxed text-foreground-600 sm:line-clamp-2 md:line-clamp-3">
            {drama.synopsis}
          </p>

          <div className="mt-2.5 flex flex-wrap items-center gap-1.5">
            {drama.tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
              >
                {tag}
              </span>
            ))}
            <span className="ml-auto hidden items-center gap-1 text-[11px] text-foreground-400 sm:flex">
              <i className="ri-time-line" aria-hidden="true" />
              {formatDate(drama.updatedAt)} 更新
            </span>
          </div>
        </div>
      </div>
    </article>
  );
}